export class CheckBin {
    public id:number;
	public rol:string;
	public comentarioOpe:string;
	public rechazar:boolean;
	public idGrupo:number;
	constructor(){
		this.id = null;
		this.rol = localStorage.getItem('currentRol');
		this.comentarioOpe = null;
		this.rechazar = false;
		this.idGrupo = null;
	}
}